import type * as z from 'zod';

import type { ContentIdKey } from '../envelope';

export type EventFamily =
	| 'app'
	| 'account'
	| 'reading'
	| 'engagement'
	| 'audio'
	| 'ads';

export interface EventDefinition<P extends z.ZodObject = z.ZodObject> {
	family: EventFamily;
	/** The event's own parameters (at most 5; the catalog test enforces it). */
	params: P;
	/**
	 * The content ids this event must carry, which can depend on its
	 * parameters (a `share` of an article needs the article's id, a `share`
	 * of an issue does not). `track()` rejects the event without them.
	 */
	requires: (params: z.output<P>) => ReadonlyArray<ContentIdKey>;
}

export function defineEvent<P extends z.ZodObject>(
	definition: EventDefinition<P>,
): EventDefinition<P> {
	return definition;
}

export const NO_CONTENT_IDS: ReadonlyArray<ContentIdKey> = [];
